// components/ConfirmationModal.js
import React from 'react';
import { FaTimes, FaExclamationTriangle, FaTrash, FaToggleOff, FaToggleOn } from 'react-icons/fa';

const ConfirmationModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title, 
  message, 
  confirmText = "Confirmar", 
  cancelText = "Cancelar",
  type = "danger", // "danger", "warning", "info"
  isLoading = false 
}) => {
  if (!isOpen) return null;

  // Configuración de colores y iconos según el tipo
  const getTypeConfig = () => {
    switch (type) {
      case 'danger':
        return {
          bgColor: 'bg-red-600/20',
          borderColor: 'border-red-600/50',
          iconColor: 'text-red-500',
          buttonColor: 'bg-red-600 hover:bg-red-700',
          icon: FaTrash
        };
      case 'warning':
        return {
          bgColor: 'bg-orange-600/20',
          borderColor: 'border-orange-600/50',
          iconColor: 'text-orange-500',
          buttonColor: 'bg-orange-600 hover:bg-orange-700',
          icon: FaToggleOff
        };
      case 'info':
        return {
          bgColor: 'bg-blue-600/20',
          borderColor: 'border-blue-600/50',
          iconColor: 'text-blue-500',
          buttonColor: 'bg-blue-600 hover:bg-blue-700',
          icon: FaToggleOn
        };
      default:
        return {
          bgColor: 'bg-red-600/20',
          borderColor: 'border-red-600/50',
          iconColor: 'text-red-500',
          buttonColor: 'bg-red-600 hover:bg-red-700',
          icon: FaExclamationTriangle
        };
    }
  };

  const config = getTypeConfig();
  const IconComponent = config.icon;

  const handleConfirm = () => {
    onConfirm();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50 backdrop-blur-sm">
      <div className="bg-zinc-800 rounded-xl shadow-2xl max-w-md w-full mx-4 border border-zinc-700 transform transition-all duration-300 scale-100">
        {/* Header */}
        <div className="flex justify-between items-start p-6 pb-4">
          <div className="flex items-center">
            <div className={`w-12 h-12 ${config.bgColor} rounded-full flex items-center justify-center mr-4 ${config.borderColor} border`}>
              <IconComponent className={`text-xl ${config.iconColor}`} />
            </div>
            <h3 className="text-xl font-bold text-white">{title}</h3>
          </div>
          <button 
            onClick={onClose}
            disabled={isLoading}
            className="text-gray-400 hover:text-white hover:bg-zinc-700 p-2 rounded-full transition-all duration-200 disabled:opacity-50"
            aria-label="Cerrar"
          >
            <FaTimes />
          </button>
        </div>
        
        {/* Content */}
        <div className="px-6 pb-6">
          <p className="text-gray-300 leading-relaxed mb-6">
            {message}
          </p>
          
          {/* Buttons */}
          <div className="flex justify-end space-x-3">
            <button
              onClick={onClose}
              disabled={isLoading}
              className="px-4 py-2 bg-zinc-700 text-white rounded-lg hover:bg-zinc-600 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {cancelText}
            </button>
            <button
              onClick={handleConfirm}
              disabled={isLoading}
              className={`px-4 py-2 text-white rounded-lg transition-all duration-200 flex items-center justify-center min-w-[100px] disabled:opacity-50 disabled:cursor-not-allowed ${config.buttonColor}`}
            >
              {isLoading ? (
                <>
                  <svg className="animate-spin h-4 w-4 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Procesando...
                </>
              ) : (
                confirmText
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;